import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { environment } from '../../environments/environment';

export interface NextWeekPlanTask {
  id: string;
  projectId: string;
  taskNumber: string;
  task: string;
  startDate: string;
  targetDate?: string;
  status: string;
  comments?: string;
}

export interface CreateNextWeekPlanTaskDto {
  projectId: string;
  taskNumber: string;
  task: string;
  startDate: string;
  targetDate?: string;
  status: string;
  comments?: string;
}

@Injectable({
  providedIn: 'root'
})
export class NextWeekPlanTaskService {
  private apiUrl = `${environment.apiUrl}/NextWeekPlanTask`;

  constructor(private http: HttpClient) { }

  getByProjectId(projectId: string): Observable<NextWeekPlanTask[]> {
    return this.http.get<NextWeekPlanTask[]>(`${this.apiUrl}/project/${projectId}`);
  }

  getById(id: string): Observable<NextWeekPlanTask> {
    return this.http.get<NextWeekPlanTask>(`${this.apiUrl}/${id}`);
  }

  addTask(task: CreateNextWeekPlanTaskDto): Observable<NextWeekPlanTask> {
    return this.http.post<NextWeekPlanTask>(this.apiUrl, task);
  }

  updateTask(id: string, task: NextWeekPlanTask): Observable<NextWeekPlanTask> {
    return this.http.put<NextWeekPlanTask>(`${this.apiUrl}/${id}`, task);
  }

  deleteTask(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}


